<div class="emojipicker">
    <button type="button" (click)="show = !show" aria-label="choisir un emoji" class="emoji-picker-button">
        <img src="/assets/images/emoji-smile.svg">
    </button>

    @if(show){
    <div class="emoji-picker">
        <div class="search-input">
            <div class="position-relative">
                <input type="text" [formControl]="searchInputCtrl" class="form-control" placeholder="{{'search_emoji' | translate}}" autocomplete="off">
                @if(searchLoading){
                <i class="far fa-spinner fa-spin"></i>
                } @else {
                <i  class="fa fa-search"></i>
                }
            </div>
        </div>
        <div class="emojis-list">
            @for(emoji of emojis; track emoji){
            <button type="button" (click)="addEmoji(emoji)">
                {{ emoji.unicode }}
            </button>
            }
        </div>
    </div>
    }
</div>